export default "__VITE_PUBLIC_ASSET__2d090321__"